// Default input horizontal padding
import { modifyProps } from '../helpers/props';
export const INPUT_HORIZONTAL_PADDING = 16;
export const INPUT_HORIZONTAL_CONDENSED_PADDING = 8;
export const INPUT_HORIZONTAL_MINIMAL_PADDING = 4;
// Default input height (excluding borders)
export const INPUT_HEIGHT = {
  xs: 44,
  md: 48,
  xl: 54
};
export const INPUT_HALF_HEIGHT = modifyProps(INPUT_HEIGHT, v => v / 2);
export const INPUT_VERTICAL_PADDING = {
  xs: 11,
  xl: 13
};
// Default input height (including borders)
export const INPUT_CONTROL_HEIGHT = {
  xs: 46,
  md: 50,
  xl: 56
};
export const INPUT_CONTROL_HALF_HEIGHT = modifyProps(INPUT_CONTROL_HEIGHT, v => v / 2);
// Default left text padding for input when it's with icon
export const INPUT_TEXT_WITH_ICON_LEFT_PADDING = {
  xs: 40,
  md: 44,
  lg: 46,
  xl: 48
};
export const INPUT_TEXT_WITH_ICON_LEFT_PADDING_SHRINKED = {
  xs: 40,
  md: 48,
  lg: 46,
  xl: 46
};
// Delta between INPUT_TEXT_WITH_ICON_LEFT_PADDING and normal INPUT_HORIZONTAL_PADDING
export const INPUT_TEXT_WITH_ICON_LEFT_PADDING_DELTA = modifyProps(INPUT_TEXT_WITH_ICON_LEFT_PADDING, v => v - INPUT_HORIZONTAL_PADDING);
// Default left padding for icon inside input
export const INPUT_ICON_LEFT_PADDING = {
  xs: '12px',
  md: '16px'
};
export const INPUT_PLACEHOLDER_WITH_ICON_SHIFT = {
  xs: '-24px',
  md: '-28px',
  lg: '-30px',
  xl: '-32px'
};
// Default form item bottom margin
export const INPUT_FORM_BOTTOM_MARGIN = {
  xs: '12px',
  md: '16px',
  lg: '24px'
};
export const INPUT_SHRINK_ANIMATION_DURATION = 200;
export const INPUT_SHRINK_ANIMATION_FUNCTION = 'cubic-bezier(0.0, 0, 0.2, 1)';
export const INPUT_SHRINK_TEXT_SCALE = 0.8;